import api from './api';
import { jwtDecode } from 'jwt-decode';

export const login = async (email, password) => {
    try {
        const response = await api.post('/auth/login', { email, password });
        const { token } = response.data;
        // Decodifica o token
        const decoded = jwtDecode(token);
        localStorage.setItem('token', token);
        localStorage.setItem('userId', decoded.id);
        localStorage.setItem('username', decoded.name);
        localStorage.setItem('role', decoded.type);
        return token;
    } catch (error) {
        throw new Error('Falha na autenticação');
    }
};

export const signUpUser = async (name, email, type, password, ) => {

    try {
        const response = await api.post('/users/', { name, email, type, password });
        return response.data;
    } catch (error) {
        throw new Error('Falha na criação de conta');
    }
};

export const signUpEconomicAgent = async (name, email, type, password, cpf_cnpj, neighborhoodId, phone, address, location, startDate, active, typeBussinesId, sectorActivitId ) => {

    try {
        const response = await api.post('/economic-agents/', { name, email, type, password, cpf_cnpj, neighborhoodId, phone, address, location, startDate, active, typeBussinesId, sectorActivitId });
        return response.data;
    } catch (error) {
        throw new Error('Falha na criação de conta');
    }
};

export const logout = (setAuthenticated) => {
    try {
        localStorage.removeItem('token');
        setAuthenticated(false);
        return true;
    }catch(error) {
        console.error(error);
        return false;
    }
};

export const getToken = () => {
    return localStorage.getItem('token');
};

export const getRole = () => {
    return localStorage.getItem('role');
};

export const isTokenExpired = () => {
    try {
        const token = localStorage.getItem('token');

        const decode = jwtDecode(token);

        const exp = decode.exp;

        const now = Math.floor(Date.now() / 1000);

        return exp < now;
    } catch (error) {
        console.error("Erro ao verificar o token:", error);
        return true;
    }
}
